interface DetailedBarChartProps {
  data: { label: string; val: number }[];
  maxVal: number;
  color?: string;
  height?: number;
}

export function DetailedBarChart({ data, maxVal, color = '#3b82f6', height = 80 }: DetailedBarChartProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-end', gap: '6px', height: `${height + 20}px` }}>
      {data.map((d) => (
        <div key={d.label} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
          <div style={{ width: '100%', display: 'flex', alignItems: 'flex-end', height: `${height}px` }}>
            <div style={{
              width: '100%',
              background: color,
              borderRadius: '4px 4px 0 0',
              height: `${Math.max(4, (d.val / maxVal) * height)}px`,
              transition: 'height 0.4s ease',
            }} />
          </div>
          <div style={{ fontSize: '10px', color: '#d4d4d4', marginTop: '4px', textAlign: 'center' }}>{d.label}</div>
        </div>
      ))}
    </div>
  );
}
